import React from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import { publicUrl } from '../config/publicOrigin';

class ErrorBoundaryInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    const { t, language } = this.props;
    
    if (this.state.hasError) {
      return (
        <div className="p-6 bg-red-500/10 border border-red-500/30 rounded-lg m-4">
          <h2 className="text-xl font-bold text-red-400 mb-2">{t('errors.somethingWentWrong')}</h2>
          <p className="text-slate-300 mb-4">{t('errors.componentError')}</p>
          <div className="flex flex-wrap gap-3">
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded text-white"
            >
              {language === 'cs' ? 'Obnovit stránku' : 'Reload page'}
            </button>
            <a
              href={publicUrl('/')}
              className="px-4 py-2 bg-slate-700 hover:bg-slate-600 rounded text-white"
            >
              {language === 'cs' ? 'Přejít na ControlVitals' : 'Go to ControlVitals'}
            </a>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const ErrorBoundary = (props) => (
  <LanguageContext.Consumer>
    {({ t, language }) => <ErrorBoundaryInner {...props} t={t} language={language} />}
  </LanguageContext.Consumer>
);

export default ErrorBoundary;
